"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconAlertWarning = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconAlertWarning = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M23.559 17.7L14.367 3.298A2.795 2.795 0 0012 2c-.964 0-1.849.485-2.367 1.297L.441 17.7a2.808 2.808 0 002.367 4.319h18.384A2.807 2.807 0 0023.56 17.7zM12 19.595a1.53 1.53 0 110-3.06 1.53 1.53 0 010 3.06zM14.121 8.96l-.753 5.075a1.368 1.368 0 01-2.703.018l-.819-5.066a2.163 2.163 0 114.275-.027z"
}));
exports.IconAlertWarning = IconAlertWarning;
//# sourceMappingURL=IconAlertWarning.js.map